import { isDevelopmentBuild } from "../shared/utils/env";

export const DEFAULT_NS = "translations";
export const LOAD_PATH = isDevelopmentBuild()
  ? "/{{ns}}/{{lng}}.json"
  : "https://static-webservicesops.akamaized.net/sponsalia/prod/land/{{ns}}/{{lng}}.json";
